export default "__VITE_ASSET__e6159f17__"